__turbopack_context__.v({
  "blue": "Carousel-module-scss-module__LLFCia__blue",
  "brown": "Carousel-module-scss-module__LLFCia__brown",
  "button": "Carousel-module-scss-module__LLFCia__button",
  "container": "Carousel-module-scss-module__LLFCia__container",
  "cream": "Carousel-module-scss-module__LLFCia__cream",
  "disableNavigation": "Carousel-module-scss-module__LLFCia__disableNavigation",
  "fade-in": "Carousel-module-scss-module__LLFCia__fade-in",
  "hideScrollBars": "Carousel-module-scss-module__LLFCia__hideScrollBars",
  "icon": "Carousel-module-scss-module__LLFCia__icon",
  "inlineIntro": "Carousel-module-scss-module__LLFCia__inlineIntro",
  "isBeginning": "Carousel-module-scss-module__LLFCia__isBeginning",
  "isInView": "Carousel-module-scss-module__LLFCia__isInView",
  "navigation": "Carousel-module-scss-module__LLFCia__navigation",
  "next": "Carousel-module-scss-module__LLFCia__next",
  "orange": "Carousel-module-scss-module__LLFCia__orange",
  "prev": "Carousel-module-scss-module__LLFCia__prev",
  "root": "Carousel-module-scss-module__LLFCia__root",
  "slide": "Carousel-module-scss-module__LLFCia__slide",
  "track": "Carousel-module-scss-module__LLFCia__track",
});
